module.exports = __webpack_public_path__ + "yubico@2x.9eaa61aa1dcd83d343ab523d26282ebe.png";